const ModalOption=()=>{
        return {
            title:"",
            element:null,
            closeModal:()=>{}    
        }
    }

export default ModalOption;